'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('./login.scss');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _login = require('../api/login.service');

var _login2 = _interopRequireDefault(_login);

var _user = require('../api/user.service');

var _user2 = _interopRequireDefault(_user);

var _toast = require('../services/toast');

var _toast2 = _interopRequireDefault(_toast);

var _login3 = require('./login.routes');

var _login4 = _interopRequireDefault(_login3);

var _login5 = require('./login.controller');

var _login6 = _interopRequireDefault(_login5);

var _resetPasswordRequest = require('./reset-password-request.controller');

var _resetPasswordRequest2 = _interopRequireDefault(_resetPasswordRequest);

var _resetPassword = require('./reset-password.controller');

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _createPassword = require('./create-password.controller');

var _createPassword2 = _interopRequireDefault(_createPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.login', [_angularUiRouter2.default, _login2.default, _user2.default, _toast2.default]).config(_login4.default).controller('LoginController', _login6.default).controller('ResetPasswordRequestController', _resetPasswordRequest2.default).controller('ResetPasswordController', _resetPassword2.default).controller('CreatePasswordController', _createPassword2.default).name;


// WEBPACK FOOTER //
// ./src/app/login/index.js